import { Reveal } from "./Reveal";
import { Chapter } from "./Chapter";
import { useContent } from "@/lib/content";
import { API } from "@/lib/api";

export const Resume = () => {
  const { credits, chapters, resumeCard, resumePhotos, colors } = useContent();
  const hasPhotos = (resumePhotos || []).length > 0;
  return (
  <section className="mx-auto max-w-7xl px-6 md:px-12 pt-16 md:pt-20 pb-32 md:pb-44" data-testid="resume-section">
    <Chapter number="02" kicker={chapters.resume.kicker} title={chapters.resume.title} id="resume" />
    <div className="mt-20 grid lg:grid-cols-12 gap-16">
      <div className={hasPhotos ? "lg:col-span-6" : "lg:col-span-8"}>
        <div className="relative border-l border-champagne pl-10 md:pl-14 space-y-14">
          {credits.map((c, i) => (
            <Reveal key={`${c.production}-${i}`} delay={Math.min(i, 4) * 0.06}>
              <div className="relative" data-testid={`resume-credit-${i}`}>
                <span aria-hidden="true" className="absolute -left-[42px] md:-left-[58px] top-2 h-2.5 w-2.5 rounded-full" style={{ backgroundColor: colors.bullet }} />
                <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-rose">{c.type}</p>
                <h3 className="mt-2 font-serif text-3xl md:text-4xl font-medium text-burgundy">{c.production}</h3>
                <p className="mt-2 text-base text-charcoal/80">
                  {c.role || (c.type === "Theatre" ? "Intimacy Director" : "Intimacy Coordinator")} · <span className="text-charcoal/60">{c.byline}</span>
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      {hasPhotos && (
        <div className="lg:col-span-3" data-testid="resume-gallery">
          <div className="space-y-8">
            {resumePhotos.map((f, i) => (
              <Reveal key={f} delay={i * 0.08} y={40} className={i >= 2 ? "hidden lg:block" : ""}>
                <div className="relative">
                  <div aria-hidden="true" className="absolute -inset-2 border border-champagne translate-x-2 translate-y-2" />
                  <img
                    src={`${API}/files/photos/${f}`}
                    alt={`On set — photo ${i + 1}`}
                    data-testid={`resume-photo-${i}`}
                    className="relative w-full aspect-[3/4] object-cover"
                  />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      )}
      <div className={hasPhotos ? "lg:col-span-3" : "lg:col-span-4"}>
        <Reveal delay={0.2}>
          <div className="sticky top-32 border border-champagne bg-ivory p-8 md:p-10" data-testid="resume-card">
            <p className="overline-label" data-testid="resume-card-title">{resumeCard.title}</p>
            <p className="mt-4 text-base leading-relaxed text-charcoal/80" data-testid="resume-card-text">
              {resumeCard.text}
            </p>
            <a
              href={`${API}/files/resume`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="resume-download-button"
              className="mt-8 inline-flex items-center rounded-full border border-burgundy px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-burgundy hover:bg-burgundy hover:text-ivory transition-colors duration-300"
            >
              {resumeCard.buttonLabel}
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
